import DOMPurify from 'dompurify';

/** 费用说明等短文案：只留行内排版 */
const INLINE = {
  ALLOWED_TAGS: ['br', 'b', 'strong', 'em', 'span'],
  ALLOWED_ATTR: [],
};

const PROFILES = {
  inline: INLINE,
};

/**
 * 消毒 HTML 后再交给 v-safe-html 渲染。
 * 不传 profile 时使用 DOMPurify 默认 HTML 配置，适合协议、FAQ、运营富文本。
 * @param {unknown} dirty
 * @param {'inline' | undefined} profile
 * @returns {string}
 */
export function sanitizeHtml(dirty, profile) {
  const html = dirty == null ? '' : String(dirty);
  const config = profile ? PROFILES[profile] : undefined;
  // 未知 profile 不回退到未消毒内容
  if (profile && !config) {
    return '';
  }
  return DOMPurify.sanitize(html, config);
}
